<template>
    <svg :width="width" :height="height" viewBox="0 0 52 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M41 19L48 12L41 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M48 12H32" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <g clip-path="url(#clip0_1_9)">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M5.99994 0C5.20429 0 4.44123 0.31607 3.87862 0.87868C3.31601 1.44129 2.99994 2.20435 2.99994 3V21C2.99994 21.7956 3.31601 22.5587 3.87862 23.1213C4.44123 23.6839 5.20429 24 5.99994 24H17.9999C18.7956 24 19.5587 23.6839 20.1213 23.1213C20.6839 22.5587 20.9999 21.7956 20.9999 21V8.121C20.9998 7.32542 20.6836 6.56248 20.1209 6L14.9999 0.879C14.4375 0.316352 13.6745 0.000169912 12.8789 0H5.99994ZM8.99994 15C8.99994 14.6022 8.8419 14.2206 8.5606 13.9393C8.2793 13.658 7.89776 13.5 7.49994 13.5C7.10212 13.5 6.72058 13.658 6.43928 13.9393C6.15798 14.2206 5.99994 14.6022 5.99994 15V19.5C5.99994 19.8978 6.15798 20.2794 6.43928 20.5607C6.72058 20.842 7.10212 21 7.49994 21C7.89776 21 8.2793 20.842 8.5606 20.5607C8.8419 20.2794 8.99994 19.8978 8.99994 19.5V15ZM11.9999 10.5C12.3978 10.5 12.7793 10.658 13.0606 10.9393C13.3419 11.2206 13.4999 11.6022 13.4999 12V19.5C13.4999 19.8978 13.3419 20.2794 13.0606 20.5607C12.7793 20.842 12.3978 21 11.9999 21C11.6021 21 11.2206 20.842 10.9393 20.5607C10.658 20.2794 10.4999 19.8978 10.4999 19.5V12C10.4999 11.6022 10.658 11.2206 10.9393 10.9393C11.2206 10.658 11.6021 10.5 11.9999 10.5V10.5ZM17.9999 9C17.9999 8.60218 17.8419 8.22064 17.5606 7.93934C17.2793 7.65804 16.8978 7.5 16.4999 7.5C16.1021 7.5 15.7206 7.65804 15.4393 7.93934C15.158 8.22064 14.9999 8.60218 14.9999 9V19.5C14.9999 19.8978 15.158 20.2794 15.4393 20.5607C15.7206 20.842 16.1021 21 16.4999 21C16.8978 21 17.2793 20.842 17.5606 20.5607C17.8419 20.2794 17.9999 19.8978 17.9999 19.5V9Z"
                  fill="currentColor"/>
        </g>
    </svg>
</template>

<script>
export default {
    name: "IconTimeControlConfirm",
    props: {
        width: {
            type: [Number, String],
            default: 52
        },
        height: {
            type: [Number, String],
            default: 24
        }
    }
}
</script>
